module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Servicios ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consejo veterinario gratuito")]), _vm._v(" "), _c('p', [_vm._v("Le escuchamos")]), _vm._v(" "), _c('p', [_vm._v("Le ofrecemos una solución global personalizada")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Venta")]), _vm._v(" "), _c('p', [_vm._v("Solo ofrecemos productos de alta calidad que hemos estudiado y probado")]), _vm._v(" "), _c('p', [_vm._v("Garantizamos en todos los productos el precio más bajo del mercado")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f441b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Es/ServicesHome.vue
// module id = 135
// module chunks = 0